import React from "react";

const TariffTable = () => {
  const data = [
    { col1: "Economy Sedan", col2: "60 CAD", col3: "378 CAD", col4: "1350 CAD" },
    { col1: "EV Sedan Tesla M3 EV", col2: "75 CAD", col3: "472 CAD", col4: "1700 CAD" },
    { col1: "Full Size Sedan", col2: "70 CAD", col3: "441 CAD", col4: "1550 CAD" },
    { col1: "SUV", col2: "75 CAD", col3: "472 CAD", col4: "1700 CAD" },
    { col1: "Minivan (8 Seater)", col2: "95 CAD", col3: "595 CAD", col4: "2100 CAD" },
  ];

  return (
    <div className="tariff-table-container">
      <h2 className="tariff-table-heading">Our Rates & Tariffs</h2>
    <table className="tariff-table">
      <thead>
        <tr>
          <th>Vehicle</th>
          <th>Day</th>
          <th>Week</th>
          <th>Month</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index} className={index % 2 === 0 ? "row-even" : "row-odd"}>
            <td>{row.col1}</td>
            <td>{row.col2}</td>
            <td>{row.col3}</td>
            <td>{row.col4}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
};



export default TariffTable;
